import React from 'react';
import { Dialog, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
  open: boolean;
  onClose: () => void;
  description: string;
};

const DescriptionModal = ({ open, onClose, description }: Props) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 5,
          p: 5,
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box textAlign="center" flex={1}>
          <Typography fontSize={28} fontWeight={600}>
            Descrição da transação
          </Typography>
          <Typography fontSize={16} color="text.secondary" mt={1}>
            Informações adicionais inseridas na transação
          </Typography>
        </Box>

        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box
        mt={6}
        sx={{
          backgroundColor: '#F7F9FB',
          borderRadius: 3,
          p: 4,
          maxHeight: 320,
          overflowY: 'auto',
          whiteSpace: 'pre-wrap',
        }}
      >
        <Typography fontSize={15} color="text.primary">
          {description || 'Nenhuma descrição informada.'}
        </Typography>
      </Box>
    </Dialog>
  );
};

export default DescriptionModal;
